var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCoin = function SvgCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 31 31",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.39 9.93c-.264 0-.573.248-.573.658 0 .353.074.446.082.455.016.02.077.087.337.179l3.368 1.179c.405.146.898.383 1.27.858.382.489.529 1.09.529 1.753 0 1.466-1.147 2.758-2.674 2.758h-2.1c-1.651 0-2.912-1.403-2.912-3.01a1.05 1.05 0 1 1 2.1 0c0 .549.419.91.812.91h2.1c.265 0 .574-.248.574-.658 0-.353-.075-.448-.083-.459-.017-.021-.076-.085-.326-.176l-3.358-1.175c-.41-.146-.91-.381-1.286-.858-.386-.49-.533-1.092-.533-1.756 0-1.466 1.147-2.758 2.674-2.758h2.114c1.637.022 2.912 1.384 2.912 3.01a1.05 1.05 0 1 1-2.1 0c0-.528-.402-.9-.835-.91h-2.091Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.567 15.74c.58 0 1.05.47 1.05 1.05v1.036a1.05 1.05 0 1 1-2.1 0V16.79c0-.58.47-1.05 1.05-1.05ZM12.567 6.724c.58 0 1.05.47 1.05 1.05v1.092a1.05 1.05 0 1 1-2.1 0V7.774c0-.58.47-1.05 1.05-1.05Z",
    fill: "#123862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.553 2.65c-5.598 0-10.136 4.538-10.136 10.136 0 5.598 4.538 10.136 10.136 10.136 5.598 0 10.136-4.538 10.136-10.136 0-5.598-4.538-10.136-10.136-10.136ZM.317 12.786C.317 6.028 5.795.55 12.553.55c6.758 0 12.236 5.478 12.236 12.236 0 6.758-5.479 12.236-12.236 12.236-6.758 0-12.236-5.478-12.236-12.236Z",
    fill: "#123862"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.589 16.387a1.05 1.05 0 0 1 1.465-.24 7.996 7.996 0 0 1 3.335 6.495c0 4.402-3.578 7.98-7.98 7.98a7.972 7.972 0 0 1-6.527-3.383 1.05 1.05 0 1 1 1.713-1.214 5.872 5.872 0 0 0 4.814 2.497 5.887 5.887 0 0 0 5.88-5.88c0-1.97-.972-3.718-2.462-4.79a1.05 1.05 0 0 1-.238-1.465Z",
    fill: "#123862"
  })));
};
export default SvgCoin;